import { render, staticRenderFns } from "./ObjectImages.vue?vue&type=template&id=23e0fbda&scoped=true&"
import script from "./ObjectImages.vue?vue&type=script&lang=js&"
export * from "./ObjectImages.vue?vue&type=script&lang=js&"
import style0 from "./ObjectImages.vue?vue&type=style&index=0&id=23e0fbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0fbda",
  null
  
)

export default component.exports